export const POPUP_VIEW = {
  popup: { clinicianInfoPopup: 'clinician-info-popup' },
};
